<template>
  <a-collapse
    class="related-threshold-apply"
    :defaultActiveKey="['related-urls']"
    :bordered="false"
    expand-icon-position="right"
  >
    <a-collapse-panel key="related-urls">
      <template slot="header">
        <div class="related-threshold-apply__header">
          <div class="related-threshold-apply__title">
            Apply to related URLs
          </div>
          <div class="related-threshold-apply__description">
            Use the selected values as minimum thresholds. Existing higher values will not be
            lowered.
          </div>
        </div>
      </template>

      <div v-if="domain" class="related-threshold-apply__option">
        <div class="related-threshold-apply__scope">
          <a-icon type="global" class="related-threshold-apply__icon" />
          <div class="related-threshold-apply__scope-content">
            <div class="related-threshold-apply__scope-label">
              Same domain
            </div>
            <div class="related-threshold-apply__scope-value" :title="domain">
              {{ domain }}
            </div>
          </div>
        </div>
        <a-button :loading="applying" @click="$emit('apply-domain')">
          Apply to domain
        </a-button>
      </div>

      <div v-if="loadingTags" class="related-threshold-apply__option">
        <a-spin size="small" />
        <span class="text-muted">
          Loading related tags…
        </span>
      </div>

      <div v-else-if="tags.length > 0" class="related-threshold-apply__option">
        <div class="related-threshold-apply__scope">
          <a-icon type="tags" class="related-threshold-apply__icon" />
          <div class="related-threshold-apply__scope-content">
            <div class="related-threshold-apply__scope-label">
              Same tag
            </div>
            <div
              v-if="tags.length === 1"
              class="related-threshold-apply__scope-value"
              :title="tags[0].name"
            >
              {{ tags[0].name }}
            </div>
            <a-select
              v-else
              v-model="selectedTagModel"
              class="related-threshold-apply__tag-select"
              placeholder="Select a tag"
              :disabled="applying"
            >
              <a-select-option
                v-for="tag in tags"
                :key="String(tag.id)"
                :value="tag.id"
              >
                {{ tag.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <a-button
          :loading="applying"
          :disabled="tags.length > 1 && selectedTagModel == null"
          @click="$emit('apply-tag', tags.length === 1 ? tags[0].id : selectedTagModel)"
        >
          Apply to tag
        </a-button>
      </div>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
export default {
  name: 'RelatedThresholdApply',
  props: {
    domain: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => []
    },
    selectedTagId: {
      type: [String, Number],
      default: null
    },
    loadingTags: {
      type: Boolean,
      default: false
    },
    applying: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedTagModel: {
      get() {
        return this.selectedTagId;
      },
      set(value) {
        this.$emit('update:selected-tag-id', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.related-threshold-apply {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
  overflow: hidden;

  ::v-deep .ant-collapse-item {
    border-bottom: 0;
  }

  ::v-deep .ant-collapse-header {
    padding: 12px 40px 12px 16px;
  }

  ::v-deep .ant-collapse-content {
    border-top: 1px solid #e8e8e8;
  }

  ::v-deep .ant-collapse-content-box {
    padding: 0;
  }

  &__title {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  &__description {
    margin-top: 2px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.45);
  }

  &__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 64px;
    padding: 10px 16px;

    & + & {
      border-top: 1px solid #eeeeee;
    }
  }

  &__scope {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 18px;
    color: #04b0ed;
  }

  &__scope-content {
    flex: 1;
    min-width: 0;
  }

  &__scope-label {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
  }

  &__scope-value {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.75);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__tag-select {
    width: 240px;
    max-width: 100%;
  }

  @media (max-width: 767px) {
    &__option {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
    }

    &__option > .ant-btn {
      width: 100%;
    }

    &__tag-select {
      width: 100%;
    }
  }
}
</style>
